import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import { ReactElement, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import CloseIcon from "@mui/icons-material/Close";

interface IParams {
    confirmLabel?: string;
    children: ReactNode;
    displayCancel?: boolean;
    isModalOpen: boolean;
    targetId?: string | number;
    title: string;
    subTitle?: ReactNode;
    hideActions?: boolean;
    closeIcon?: ReactElement<{ onClick: () => void }>;
    topOffset?: number;
    maxWidth?: DialogProps["maxWidth"];
    close(): void;
    confirm?(id?: string | number): void;
}

export const Modal = (props: IParams) => {
    const { t } = useTranslation("common");
    const {
        children,
        isModalOpen,
        displayCancel = false,
        targetId,
        title,
        subTitle,
        hideActions,
        closeIcon,
        topOffset,
        maxWidth,
        close,
        confirm,
        confirmLabel = t("confirm"),
    } = props;
    const { classes, cx } = useStyle({ topOffset });

    return (
        <Dialog
            className={cx(topOffset !== undefined && classes.dialogAlignTop)}
            fullWidth
            maxWidth={maxWidth ?? "md"}
            open={isModalOpen}
            onClose={close}
        >
            <Grid className={classes.dialogClose} container justifyContent="flex-end">
                <Grid className={classes.dialogCloseIcon} item>
                    <IconButton aria-label="close" edge="end" onClick={close}>
                        {closeIcon ?? <CloseIcon color="disabled" />}
                    </IconButton>
                </Grid>
            </Grid>
            <DialogTitle>
                <Grid container gap={0.5} justifyContent="center">
                    <Grid item sm={12} xs={9}>
                        <Typography align="center" color="secondary" variant="h3">
                            {title}
                        </Typography>
                    </Grid>
                    {subTitle && (
                        <Grid item sm={12} xs={9}>
                            <Typography align="center" color="secondary" variant="large" whiteSpace="pre-line">
                                {subTitle}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            {!hideActions && (
                <DialogActions>
                    <Grid container justifyContent="center" spacing={2}>
                        {displayCancel && (
                            <Grid item md={2} sm={3} xs={6}>
                                <Button
                                    className="xtest_modal_close_button"
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    onClick={close}
                                >
                                    {t("cancel")}
                                </Button>
                            </Grid>
                        )}
                        {confirm && (
                            <Grid item md={2} sm={3} xs={6}>
                                <Button
                                    className="xtest_modal_confirm_button"
                                    color="secondary"
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    onClick={() => confirm(targetId)}
                                >
                                    {confirmLabel}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </DialogActions>
            )}
        </Dialog>
    );
};
